import React from 'react'
import { connect } from 'react-redux'

import InactiveReport from './InactiveReport'
import { fetchInactiveReportList } from './actions'


class InactiveReportList extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        let date = new Date()
        let daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

        let startDate = date.getFullYear() + "-"
        let endDate = date.getFullYear() + "-"

        var month = date.getMonth()

        var lastday = daysInMonths[month - 1 == -1 ? 0 : month - 1]

        if (month < 10) {
            startDate = startDate + "0" + month + "-" + "01"
            endDate = endDate + "0" + month + "-" + lastday
        }
        else {
            startDate = startDate + month + "-" + "01"
            endDate = endDate + month + "-" + lastday
        }

        let report = {
            startDate: startDate,
            endDate: endDate
        }

        fetchInactiveReportList.bind(this)(report)
    }

    render() {
        return (
            <InactiveReport inactiveReportData={this.props.inactivereport.inactiveReportData} />
        );
    }
}

const mapStateToProps = state => ({
    inactivereport: state.inactivereport
});

export default connect(mapStateToProps)(InactiveReportList)
